(function protectImages() {
  // Bloquea el menú contextual (clic derecho / pulsación larga) sobre imágenes,
  // para dificultar "Guardar imagen como" y similares.
  document.addEventListener('contextmenu', function (event) {
    if (event.target instanceof Element && event.target.closest('img, picture, [data-protect-image]')) {
      event.preventDefault();
    }
  });

  // Bloquea el arrastre nativo de imágenes (drag & drop a escritorio).
  document.addEventListener('dragstart', function (event) {
    if (event.target instanceof Element && event.target.closest('img, picture, [data-protect-image]')) {
      event.preventDefault();
    }
  });
})();
